<template>
  <hooper-container
    class="rounded-xl overflow-hidden slide-container"
    style="height: auto"
    ref="carousel"
    :wheelControl="false"
    :infiniteScroll="images.length > 1"
  >
    <hooper-slide
      class="slide-item"
      v-for="(img, keyImages) in images"
      :key="keyImages"
    >
      <img
        class="d-block item-img"
        :src="img + '?resize=1&w=800'"
        width="100%"
      />
    </hooper-slide>

    <hooper-navigation
      v-if="images.length > 1"
      slot="hooper-addons"
    ></hooper-navigation>
  </hooper-container>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-container::v-deep {
  ol,
  ul {
    padding-left: 0;
  }

  .item-img {
    aspect-ratio: 4 / 3;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .hooper-track {
    transition: transform 0s 0.5s !important;
  }

  .hooper-slide,
  .hooper-slide.is-prev,
  .hooper-slide.is-next {
    transition: opacity 1s 0s;
    opacity: 0 !important;
  }

  .hooper-slide.is-active {
    transition-delay: 0.5s;
    opacity: 1 !important;
  }

  .hooper-prev,
  .hooper-next {
    svg {
      height: 48px;
      fill: white;
      opacity: 0.7;
      width: 48px;
    }

    &:hover {
      svg {
        opacity: 1;
      }
    }
  }
}
</style>
